"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["classes", "title", "contentText", "logoffText", "continueText", "onLogoff", "onContinue", "hideLogoffButton"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      margin: theme.spacing(1)
    },
    dialogPaper: {}
  };
};
var AuthTimeout = /*#__PURE__*/function (_Component) {
  function AuthTimeout(props) {
    (0, _classCallCheck2["default"])(this, AuthTimeout);
    return _callSuper(this, AuthTimeout, [props]);
  }
  (0, _inherits2["default"])(AuthTimeout, _Component);
  return (0, _createClass2["default"])(AuthTimeout, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        title = _this$props.title,
        contentText = _this$props.contentText,
        logoffText = _this$props.logoffText,
        continueText = _this$props.continueText,
        onLogoff = _this$props.onLogoff,
        onContinue = _this$props.onContinue,
        hideLogoffButton = _this$props.hideLogoffButton,
        other = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var handleClose = function handleClose(_ref, reason) {
        (0, _objectDestructuringEmpty2["default"])(_ref);
        if (reason !== "backdropClick") {
          _this.props.onContinue;
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
        classes: {
          paper: classes.dialogPaper
        },
        onClose: handleClose,
        "aria-labelledby": "auth-timeout"
      }, other), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, contentText), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return onContinue();
        }
      }, continueText), !hideLogoffButton && /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return onLogoff();
        }
      }, logoffText)));
    }
  }]);
}(_react.Component);
AuthTimeout.propTypes = {
  onLogoff: _propTypes["default"].func.isRequired,
  onContinue: _propTypes["default"].func.isRequired,
  contentText: _propTypes["default"].string.isRequired,
  continueText: _propTypes["default"].string,
  logoffText: _propTypes["default"].string
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(AuthTimeout);